<template lang="pug">
  #app
    slot
</template>

<script>
export default {
  name: "Wrapper",

  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },

  provide() {
    const foo = {};

    Object.defineProperty(foo, "bar", {
      get: () => this.dark
    });

    return { foo };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped></style>
